import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { useLang } from "@/i18n";

const KEY = "mediolanum_cookie_consent";

export default function CookieBanner() {
  const [show, setShow] = useState(false);
  const { t } = useLang();

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setShow(true);
  }, []);

  const choose = (value) => {
    localStorage.setItem(KEY, value);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-[70] px-4 pb-4 sm:px-6 sm:pb-6"
      data-testid="cookie-banner"
      role="dialog"
      aria-label="Informativa cookie"
    >
      <div className="card-surface mx-auto flex max-w-4xl flex-col gap-5 rounded-2xl border-gold/25 bg-[#0A1120]/95 p-6 shadow-2xl shadow-black/50 backdrop-blur-xl sm:flex-row sm:items-center sm:p-7">
        <div className="flex items-start gap-4">
          <span className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-gold/40 text-gold">
            <Cookie size={18} />
          </span>
          <div>
            <p className="font-serif text-lg text-slate-100">{t("Rispettiamo la vostra riservatezza")}</p>
            <p className="mt-1.5 text-sm font-light leading-relaxed text-slate-400">
              {t("Questo sito utilizza cookie tecnici necessari al funzionamento e, previo consenso, cookie di analisi anonima per migliorare l'esperienza di navigazione. Maggiori dettagli nella")}{" "}
              <Link to="/privacy" className="text-gold-light underline decoration-gold/40 underline-offset-2 transition-colors hover:text-gold" data-testid="cookie-privacy-link">
                {t("Privacy & Cookie Policy")}
              </Link>.
            </p>
          </div>
        </div>
        <div className="flex shrink-0 flex-col gap-2.5 sm:flex-row sm:items-center">
          <button
            onClick={() => choose("necessary")}
            data-testid="cookie-necessary-btn"
            className="rounded-full border border-white/20 px-6 py-2.5 text-sm text-slate-300 transition-colors hover:border-gold/60 hover:text-gold"
          >
            {t("Solo necessari")}
          </button>
          <button
            onClick={() => choose("all")}
            data-testid="cookie-accept-btn"
            className="rounded-full bg-gold px-6 py-2.5 text-sm font-semibold text-navy-950 transition-colors hover:bg-gold-light"
          >
            {t("Accetta tutti")}
          </button>
        </div>
      </div>
    </div>
  );
}
